import { createContext, useContext } from "react";
import useDiscoveryObjections from "../hooks/useDiscoveryObjections";

const DiscoveryObjectionContext = createContext(null)

export const DiscoveryObjectionProvider = ({ children }) => {
    const value = useDiscoveryObjections()

    return <DiscoveryObjectionContext.Provider value={value}>
        {children}
    </DiscoveryObjectionContext.Provider>
}

export const useDiscoveryObjectionContext = () => {
    const context = useContext(DiscoveryObjectionContext)

    if (!context) {
        throw new Error("useDiscoveryObjectionContext must be used within DiscoveryObjectionProvide");
    }

    return context;

}